import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

/**
 * Lightweight service for communication between the execution component
 * and dynamically loaded interactive step components.
 * Step components inject this service and emit their results/cancellation.
 */
@Injectable()
export class StepCommunicationService {
  private readonly _submitted = new Subject<any>();
  /** Emits when user submits data from an interactive step. */
  readonly submitted$ = this._submitted.asObservable();
  private readonly _cancelled = new Subject<void>();
  /** Emits when user cancels an interactive step. */
  readonly cancelled$ = this._cancelled.asObservable();

  /** Called by step components to submit user input. */
  submit(data: any): void {
    this._submitted.next(data);
  }

  /** Called by step components to signal cancellation. */
  cancel(): void {
    this._cancelled.next();
  }
}
